import crecerFormsInstance from 'src/services/api/crecer';

export const fetchRelationInscription = ({
  inputs,
  identification,
  phone,
  captcha,
  captchaRequired,
}) =>
  crecerFormsInstance.checkInRelationInscription({
    ...inputs,
    identification,
    phone,
    ...(captchaRequired ? { captcha } : {}),
  });
